import { EStatus } from '../types/offers';
import * as React from 'react';
import { addToComparison, removeFromComparison } from '../services/comparison';
import { NewbuildingLayoutsContext } from '../shared/context';
import { EComparisonNotificationCategory } from '../types/comparison';
export function useCompareRequests(_ref) {
  let {
    setComparisonStatus
  } = _ref;
  const {
    httpApi,
    logger
  } = React.useContext(NewbuildingLayoutsContext);
  const [notification, setNotification] = React.useState(null);
  const addOfferToComparison = React.useCallback(offerId => {
    setComparisonStatus(offerId, EStatus.Added);
    addToComparison({
      httpApi,
      logger,
      params: {
        offerId
      }
    }).then(result => {
      if (!result) {
        setComparisonStatus(offerId, EStatus.Available);
        return;
      }
      if (result.category === EComparisonNotificationCategory.Limit) {
        setComparisonStatus(offerId, EStatus.Available);
      }
      setNotification(result);
    });
  }, [setComparisonStatus]);
  const removeOfferFromComparison = React.useCallback(offerId => {
    setComparisonStatus(offerId, EStatus.Available);
    removeFromComparison({
      httpApi,
      logger,
      params: {
        offerId
      }
    }).then(result => {
      if (!result) {
        setComparisonStatus(offerId, EStatus.Added);
        return;
      }
      setNotification(result);
    });
  }, [setComparisonStatus]);
  const clearNotification = React.useCallback(() => {
    setNotification(null);
  }, []);
  return {
    addOfferToComparison,
    removeOfferFromComparison,
    clearNotification,
    notification
  };
}